import { ScaleWithValueType } from './SupportedScale';

export const getNormalizedAnimatedScaleProps = <T>(
  value: T,
  scaleFn: ScaleWithValueType<T>,
): {
  normalizedValue?: number;
  normalizedOffset?: number;
  bandwidth?: number;
} => {
  const scaledValue = scaleFn(value);
  const [rangeStart, rangeEnd] = scaleFn.range();

  // In the unlikely event the range has zero width, use a very small value to preempt
  // divide-by-zero issues
  const rangeOfRange = Math.abs(rangeEnd - rangeStart) < Number.EPSILON ? Number.EPSILON : rangeEnd - rangeStart;

  // Normalize the value to an output range of [0, (+/-)1]. This isolates changes in the value
  // itself from changes in the scale's range (e.g., due to a resize).
  const normalizedValue =
    scaledValue !== undefined && !Number.isNaN(scaledValue) ? (scaledValue - rangeStart) / rangeOfRange : undefined;

  // For band scales, calculate a normalized bandwidth and offset. The offset accounts for the need
  // to center ticks in a band scale at some offset from where the tick is placed according to the
  // scale itself.
  const bandwidth = 'bandwidth' in scaleFn ? scaleFn.bandwidth() : undefined;
  const normalizedBandwidth = bandwidth === undefined ? 0 : bandwidth / rangeOfRange;
  const normalizedOffset = bandwidth === undefined ? 0 : bandwidth / 2 / rangeOfRange;

  return {
    ...(normalizedValue !== undefined && { normalizedValue }),
    ...(normalizedOffset !== undefined && { normalizedOffset }),
    ...(bandwidth !== undefined && { bandwidth: normalizedBandwidth }),
  };
};
